// export default {
//   host: process.env.NODE_ENV === "development" ? "/api" : "/upapi",
//   loginUrl:
//     process.env.NODE_ENV === "development"
//       ? "//d-account.5118.com/account/login?status=ai"
//       : "//p-account.5118.com/account/login?status=ai",
//   registerUrl:
//     process.env.NODE_ENV === "development"
//       ? "//localhost:5000/register"
//       : "//preview.5ce.com/register",
//   wycLink:
//     process.env.NODE_ENV === "development"
//       ? "//d-wyc.5118.com/ai?token="
//       : "//a-wyc.5118.com/ai?token=",
//   settingUrl:
//     process.env.NODE_ENV === "development"
//       ? "//account.5118.com/signin/update"
//       : "//p-account.5118.com/signin/update",
//   logout: process.env.NODE_ENV === "development" ? "/logout" : "/logout",
//   sucaiUrl:
//     process.env.NODE_ENV === "development"
//       ? "//localhost:5000"
//       : "//preview.5ce.com",
//   vipUrl:
//     process.env.NODE_ENV === "development"
//       ? "//dev.5118.com"
//       : "//preview.5118.com",
//   imageUploadUrl:
//     process.env.NODE_ENV === "development"
//       ? "https://imgcc-src.5ce.com"
//       : "https://imgcc-src.5ce.com",
//   imageShowUrl:
//     process.env.NODE_ENV === "development"
//       ? "https://imgcc.5ce.com/"
//       : "https://imgcc.5ce.com/",
//   imageSaveUrl:
//     process.env.NODE_ENV === "development"
//       ? "picapi"
//       : "https://ai.5ce.com/longpic",
//   importFileUrl:
//     process.env.NODE_ENV === "development"
//       ? "/api/import/file"
//       : "//preview.5ce.com/api/import/file",
//   jumpAiUrl:
//     process.env.NODE_ENV === "development"
//       ? "//www.5ce.com"
//       : "//preview.5ce.com",
//   jumpLoginUrl:
//     process.env.NODE_ENV === "development"
//       ? "//d-account.5118.com/account/login?status=ai"
//       : "//p-account.5118.com/account/login?status=ai",
//   cookieDomain:
//     process.env.NODE_ENV === "development" ? "localhost" : ".5ce.com",
//   LongPicHost:
//     process.env.NODE_ENV === "development"
//       ? "https://ai.5ce.com"
//       : "https://ai.5ce.com",
//   payVipUrl:
//     process.env.NODE_ENV === "development"
//       ? "//d-account.5118.com/account/MediaLoginConfirm?r=//d-account.5118.com"
//       : "//p-account.5118.com/account/MediaLoginConfirm?r=//p-account.5118.com",
//   indexVipUrl:
//     process.env.NODE_ENV === "development"
//       ? "//d-account.5118.com/account/MediaLoginConfirm?r=//dev.5118.com"
//       : "//p-account.5118.com/account/MediaLoginConfirm?r=//preview.5118.com",
//   paySVipUrl:
//     process.env.NODE_ENV === "development"
//       ? "//d-account.5118.com/account/MediaLoginConfirm?r={0}&code={1}"
//       : "//p-account.5118.com/account/MediaLoginConfirm?r={0}&code={1}",
//   buySvipUrl:
//     process.env.NODE_ENV === "development"
//       ? "//d-account.5118.com/member?m=svip&p=price&b=up&r=0&buyType=100"
//       : "//p-account.5118.com/member?m=svip&p=price&b=up&r=0&buyType=100",
//   wyc5118Url:
//     process.env.NODE_ENV === "development"
//       ? "//d-wyc.5118.com"
//       : "//p-wyc.5118.com",
//   so5118Url:
//     process.env.NODE_ENV === "development" ? "//so.5118.com" : "//so.5118.com",
//   yx5118Url:
//     process.env.NODE_ENV === "development"
//       ? "//d-yx.5118.com/{0}"
//       : "//p-yx.5118.com/{0}"
// };

export default {
  host: process.env.NODE_ENV === "development" ? "/api" : "/upapi",
  loginUrl:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com/account/login?status=ai"
      : "//account.5118.com/account/login?status=ai",
  wycLink:
    process.env.NODE_ENV === "development"
      ? "//d-wyc.5118.com/ai?token="
      : "//ai-wyc.5118.com/ai?token=",
  settingUrl:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com/signin/update"
      : "//account.5118.com/signin/update",
  logout:
    process.env.NODE_ENV === "development"
      ? "//localhost:5000/logout"
      : "//www.5ce.com/logout",
  sucaiUrl:
    process.env.NODE_ENV === "development"
      ? "//localhost:5000"
      : "//www.5ce.com",
  vipUrl:
    process.env.NODE_ENV === "development"
      ? "//dev.5118.com"
      : "//www.5118.com",
  imageUploadUrl:
    process.env.NODE_ENV === "development"
      ? "//imgcc-src.5ce.com"
      : "//imgcc-src.5ce.com",
  imageShowUrl:
    process.env.NODE_ENV === "development"
      ? "//imgcc.5ce.com/"
      : "//imgcc.5ce.com/",
  imageSaveUrl:
    process.env.NODE_ENV === "development"
      ? "picapi"
      : "https://ai.5ce.com/longpic",
  importFileUrl:
    process.env.NODE_ENV === "development"
      ? "/api/import/file"
      : "//www.5ce.com/api/import/file",
  jumpAiUrl:
    process.env.NODE_ENV === "development" ? "//www.5ce.com" : "//www.5ce.com",
  jumpLoginUrl:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com/account/login?status=ai"
      : "//account.5118.com/account/login?status=ai",
  cookieDomain:
    process.env.NODE_ENV === "development" ? "localhost" : ".5ce.com",
  LongPicHost:
    process.env.NODE_ENV === "development"
      ? "https://ai.5ce.com"
      : "https://ai.5ce.com",
  payVipUrl:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com/account/MediaLoginConfirm?r=//d-account.5118.com"
      : "//account.5118.com/account/MediaLoginConfirm?r=//account.5118.com",
  indexVipUrl:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com/account/MediaLoginConfirm?r=//dev.5118.com"
      : "//account.5118.com/account/MediaLoginConfirm?r=//www.5118.com",
  paySVipUrl:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com/account/MediaLoginConfirm?r={0}&code={1}"
      : "//account.5118.com/account/MediaLoginConfirm?r={0}&code={1}",
  buySvipUrl:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com/member?m=svip&p=price&b=up&r=0&buyType=100"
      : "//account.5118.com/member?m=svip&p=price&b=up&r=0&buyType=100",
  wyc5118Url:
    process.env.NODE_ENV === "development"
      ? "//d-wyc.5118.com"
      : "//wyc.5118.com",
  so5118Url:
    process.env.NODE_ENV === "development" ? "//so.5118.com" : "//so.5118.com",
  yx5118Url:
    process.env.NODE_ENV === "development"
      ? "//d-yx.5118.com/{0}"
      : "//yx.5118.com/{0}",
  account:
    process.env.NODE_ENV === "development"
      ? "//d-account.5118.com"
      : "//account.5118.com",
  www:
    process.env.NODE_ENV === "development"
      ? "//dev.5118.com"
      : "//www.5118.com"
};
